import { theme as baseTheme } from '../aidu/index.js';
export const colors = {
  ...baseTheme.colors,
  contentBrand: '#004D73',
  interactionSuccess: '#4CB21C',
  interactionSuccessHover: '#44A019',
  interactionSuccessPressed: '#3D8E16',
  interactionPrimary: '#CA8700',
  interactionPrimaryHover: '#B67A00',
  interactionPrimaryPressed: '#A26C00',
  interactionSecondary: '#007AB8',
  interactionSecondaryHover: '#006EA6',
  interactionSecondaryPressed: '#006293',
  interactionDanger: '#DA4833',
  interactionDangerHover: '#C4412E',
  interactionDangerPressed: '#AE3A29',
  backgroundBrand: '#004D73',
  backgroundBrandDark: '#003E5C',
  backgroundInteractionSecondaryTransparentDark: 'rgba(0, 77, 115, 0.8)',
  backgroundInteractionSecondaryTransparentLight: 'rgba(0, 77, 115, 0.3)',
  backgroundStateSelectedTransparent: 'rgba(0, 77, 115, 0.1)',
  backgroundStateSelected: '#E5EDF1',
  borderSelection: '#007AB8',
  systemError: '#DA4833',
  systemErrorAlert: '#AE3A29',
  systemErrorBackground: '#FBEDEB',
  systemErrorHover: '#C4412E',
  systemErrorBackgroundHover: '#F8DAD6',
  systemErrorBackgroundPressed: '#F4C8C2',
  systemPositive: '#4CB21C',
  systemPositiveHover: '#44A019',
  systemPositiveAlert: '#3D8E16',
  systemPositiveBackground: '#EDF7E8',
  systemPositiveBackgroundHover: '#DBF0D2',
  systemPositiveBackgroundPressed: '#C9E8BB',
  brandA: '#004D73',
  brandB: '#FABD0A',
  brandC: '#FEDB40',
  // component specific overrides, use sparingly!
  buttonPrimaryInfoColor: '#222222',
  // contentPrimary
  buttonPrimarySuccessColor: '#222222',
  // contentPrimary
  buttonPrimaryWarningColor: '#222222' // contentPrimary
};